// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-text {
  display: flex;
}

input {
  width: 100%;
  height: 90%;
}

.text {
  width: 90%;
}

button {
  background-color: green;
}

.text-btn {
  color: white !important;
}

.all {
  height: 100%;
}

img {
  width: 50px;
  margin-left: 5px;
  margin-top: 5px;
  border-radius: 20px;
}

.ticket-parent {
  width: 90%;
  border: solid 2px palevioletred;
  border-radius: 10px;
}

.ticket-parent-customer {
  width: 90%;
  border: solid 2px purple;
  border-radius: 10px;
}

.message {
  direction: rtl;
  margin-right: 5px;
}

.ticket-parent-admin {
  width: 90%;
  border: solid 2px green;
  border-radius: 10px;
}

.infor-msg {
  font-size: small;
}
.infor-msg span {
  font-size: small;
}

form {
  margin-left: 10px;
}

button.mdc-button.mat-mdc-button.mat-unthemed.mat-mdc-button-base[_ngcontent-ng-c3396598950] {
  height: 50px;
  width: 90px;
  margin-bottom: 7px;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

h1 {
  font-size: larger;
}

.message-div {
  margin-bottom: 23px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/services/services-ticket/services-ticket.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/services/services-ticket/services-ticket.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;ACCJ;;ADEA;EACI,WAAA;EACA,WAAA;ACCJ;;ADEA;EACI,UAAA;ACCJ;;ADEA;EACI,uBAAA;ACCJ;;ADEA;EACI,uBAAA;ACCJ;;ADEA;EACI,YAAA;ACCJ;;ADEA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,UAAA;EACA,+BAAA;EACA,mBAAA;ACCJ;;ADCA;EACI,UAAA;EACA,wBAAA;EACA,mBAAA;ACEJ;;ADAA;EACI,cAAA;EACA,iBAAA;ACGJ;;ADAA;EACI,UAAA;EACA,uBAAA;EACA,mBAAA;ACGJ;;ADAA;EACI,gBAAA;ACGJ;ADDI;EACI,gBAAA;ACGR;;ADCA;EACI,iBAAA;ACEJ;;ADCA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;ACEJ;;ADCA;EACI,aAAA;EACA,YAAA;EACA,aAAA;ACEJ;;ADCA;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACEJ;;ADCA;EACI,iBAAA;ACEJ;;ADAA;EACI,mBAAA;ACGJ","sourcesContent":[".parent-text {\r\n    display: flex;\r\n}\r\n\r\ninput {\r\n    width: 100%;\r\n    height: 90%;\r\n}\r\n\r\n.text {\r\n    width: 90%;\r\n}\r\n\r\nbutton {\r\n    background-color: green;\r\n}\r\n\r\n.text-btn {\r\n    color: white !important;\r\n}\r\n\r\n.all {\r\n    height: 100%;\r\n}\r\n\r\nimg {\r\n    width: 50px;\r\n    margin-left: 5px;\r\n    margin-top: 5px;\r\n    border-radius: 20px;\r\n}\r\n\r\n.ticket-parent {\r\n    width: 90%;\r\n    border: solid 2px palevioletred;\r\n    border-radius: 10px;\r\n}\r\n.ticket-parent-customer{\r\n    width: 90%;\r\n    border: solid 2px purple;\r\n    border-radius: 10px;\r\n}\r\n.message {\r\n    direction: rtl;\r\n    margin-right: 5px;\r\n}\r\n\r\n.ticket-parent-admin {\r\n    width: 90%;\r\n    border: solid 2px green;\r\n    border-radius: 10px;\r\n}\r\n\r\n.infor-msg {\r\n    font-size: small;\r\n\r\n    span {\r\n        font-size: small;\r\n    }\r\n}\r\n\r\nform {\r\n    margin-left: 10px;\r\n}\r\n\r\nbutton.mdc-button.mat-mdc-button.mat-unthemed.mat-mdc-button-base[_ngcontent-ng-c3396598950] {\r\n    height: 50px;\r\n    width: 90px;\r\n    margin-bottom: 7px;\r\n}\r\n\r\n.parent-both {\r\n    display: flex;\r\n    margin: auto;\r\n    padding: 20px;\r\n}\r\n\r\n.title {\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\nh1 {\r\n    font-size: larger;\r\n}\r\n.message-div {\r\n    margin-bottom: 23px;\r\n}",".parent-text {\n  display: flex;\n}\n\ninput {\n  width: 100%;\n  height: 90%;\n}\n\n.text {\n  width: 90%;\n}\n\nbutton {\n  background-color: green;\n}\n\n.text-btn {\n  color: white !important;\n}\n\n.all {\n  height: 100%;\n}\n\nimg {\n  width: 50px;\n  margin-left: 5px;\n  margin-top: 5px;\n  border-radius: 20px;\n}\n\n.ticket-parent {\n  width: 90%;\n  border: solid 2px palevioletred;\n  border-radius: 10px;\n}\n\n.ticket-parent-customer {\n  width: 90%;\n  border: solid 2px purple;\n  border-radius: 10px;\n}\n\n.message {\n  direction: rtl;\n  margin-right: 5px;\n}\n\n.ticket-parent-admin {\n  width: 90%;\n  border: solid 2px green;\n  border-radius: 10px;\n}\n\n.infor-msg {\n  font-size: small;\n}\n.infor-msg span {\n  font-size: small;\n}\n\nform {\n  margin-left: 10px;\n}\n\nbutton.mdc-button.mat-mdc-button.mat-unthemed.mat-mdc-button-base[_ngcontent-ng-c3396598950] {\n  height: 50px;\n  width: 90px;\n  margin-bottom: 7px;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nh1 {\n  font-size: larger;\n}\n\n.message-div {\n  margin-bottom: 23px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
